import React from "react";
import { Input, Button, Form, Spin } from "antd";
import { useAddAdminMutation } from "../../redux/Auth/auth";
import { toast } from "react-toastify";

function SuperAdmin() {
  const [addAdmin, { isLoading, isSuccess }] = useAddAdminMutation();

  const handleAdd = async (value) => {
    const dataAdmin = {
      fullName: value.fullName,
      username: value.userName,
      password: value.password,
    };
    await addAdmin(dataAdmin);
    toast.success("Added");
  };
  return (
    <div className="supAdmin">
      <Spin spinning={isLoading}>
        <div className="supAdmin__form-content" tip="Loading">
          <Form
            name="basic"
            onFinish={handleAdd}
            autoComplete="off"
            className="supAdmin__form"
            layout="vertical"
          >
            <Form.Item
              label="Full name"
              name="fullName"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="User name"
              name="userName"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Spin>
    </div>
  );
}

export default SuperAdmin;
